import { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import contentConfig from '@/modules/content/config';
import { IHeroProps } from '@/modules/corporate/components/DetailPageComponents/DetailHero/types';
import { ResourceTypeEnum } from '@/types/schema';

import { QuizDetailsContentFragment } from '../../graphql/fragments/generated/QuizDetailsContent';
import { QuizDetailsPerformanceFragment } from '../../graphql/fragments/generated/QuizDetailsPerformance';
import { getQuizDetailsBackground } from '../../utils/getQuizDetailsBackground';

const quizConfig = contentConfig[ResourceTypeEnum.Quiz];

const useQuizDetailsHero = (
  content: QuizDetailsContentFragment,
  quizPerformance?: QuizDetailsPerformanceFragment,
): IHeroProps => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      contentId: content.id,
      contentType: content.type,
      title: content.name,
      label: t(quizConfig.label.title),
      objective: content.objective!,
      duration: content.duration!,
      imageUrl: content.cover?.url!,
      dueDate: quizPerformance?.enrolmentInfo?.dueDate!,
      bookmark: content.bookmark,
      background: getQuizDetailsBackground(),
    }),
    [content, quizPerformance, t],
  );
};

export default useQuizDetailsHero;
